import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const PromotionalOne = () => {
  const [categories, setCategories] = useState([]);

  const WC_URL = process.env.REACT_APP_WC_URL;
  const CK = process.env.REACT_APP_WC_CK;
  const CS = process.env.REACT_APP_WC_CS;

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/api/promo-categories/`
        );

        const data = await res.json();

        if (data.status) {
          setCategories(data.data);
        } else {
          console.error("Category fetch failed", data.error);
        }
      } catch (err) {
        console.error("Category fetch error:", err);
      }
    };

    fetchCategories();
  }, []);

  return (
    <section className="promotional-banner pt-80">
      <div className="container container-lg">
        <div className="row gy-4">
          {categories.map(cat => (
            <div key={cat.id} className="col-xl-3 col-sm-6">
              <div
                className="promotional-banner-item position-relative rounded-24 overflow-hidden z-1 shadow-lg"
                style={{
                  height: '320px',
                  transition: 'all 0.3s ease',
                  cursor: 'pointer'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-8px)';
                  e.currentTarget.style.boxShadow = '0 12px 24px rgba(0,0,0,0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 4px 6px rgba(0,0,0,0.1)';
                }}
              >
                {/* Background Image with Overlay */}
                <div className="position-absolute w-100 h-100 top-0 start-0 z-n1">
                  <img
                    src={cat.image?.src}
                    alt={cat.name}
                    className="w-100 h-100 object-fit-cover"
                    style={{ filter: "brightness(0.7)" }}
                  />
                  {/* Gradient Overlay */}
                  <div
                    className="position-absolute w-100 h-100 top-0 start-0"
                    style={{
                      background: 'linear-gradient(135deg, rgba(0,0,0,0.5) 0%, rgba(0,0,0,0.2) 100%)'
                    }}
                  />
                </div>

                {/* Content */}
                <div className="promotional-banner-item__content h-100 d-flex flex-column justify-content-between p-4">
                  <div>
                    <span
                      className="badge text-uppercase mb-2"
                      style={{
                        backgroundColor: 'rgba(255, 193, 7, 0.9)',
                        color: '#000',
                        fontSize: '11px',
                        fontWeight: '600',
                        letterSpacing: '1px',
                        padding: '6px 12px'
                      }}
                    >
                      Fresh Daily
                    </span>
                    <h6
                      className="promotional-banner-item__title text-white mb-2"
                      style={{
                        fontSize: '28px',
                        fontWeight: '700',
                        lineHeight: '1.2',
                        textShadow: '2px 2px 4px rgba(0,0,0,0.3)'
                      }}
                    >
                      {cat.name}
                    </h6>
                    <p
                      className="text-white mb-0"
                      style={{
                        fontSize: '14px',
                        opacity: '0.95',
                        fontWeight: '400'
                      }}
                    >
                      Best quality guaranteed
                    </p>
                  </div>

                  <Link
                    to={`/shop?category=${cat.id}`}
                    className="btn btn-light rounded-pill align-self-start"
                    style={{
                      fontWeight: '600',
                      fontSize: '14px',
                      padding: '10px 24px',
                      transition: 'all 0.3s ease',
                      border: 'none',
                      backgroundColor: 'rgb(41, 158, 96)',
                      color: '#000'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = '#ffc107';
                      e.currentTarget.style.transform = 'scale(1.05)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = 'rgb(41, 158, 96)';
                      e.currentTarget.style.transform = 'scale(1)';
                    }}
                  >
                    Shop Now →
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PromotionalOne;